import React, {useRef, useState} from 'react';
import {Avatar, Dropdown, Menu, MenuProps} from 'antd';
import {UserOutlined, DeleteOutlined, EditOutlined} from '@ant-design/icons';
import {useViewerStore} from "../../../../store/store";
import azureBLOBStorageService from "../../../../services/azureBLOBStorageService";
import {useCurrentUser} from "../../../../contexts/UserContext";

const ProfileAvatar = () => {
    const {user} = useCurrentUser();
    const profilePhotoInput = useRef<HTMLInputElement>(null);
    const isProfilePhotoAvailable = useViewerStore(state => state.isProfilePhotoAvailable);
    const userProfilePhoto = useViewerStore(state => state.userProfilePhoto);
    const [open, setOpen] = useState(false);

    const uploadProfilePhotoHandler = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async () => {
                if(reader.result === null) return
                const imageDataUrl = reader.result as string;
                useViewerStore.setState({userProfilePhoto: imageDataUrl});
                useViewerStore.setState({isProfilePhotoAvailable: true});

                const filename = `${user?.user_Id}.png`;
                const fileToUpload = new File([file], filename, {type: file.type});
                const response = await azureBLOBStorageService.uploadFile(fileToUpload);

                if (response !== true) {
                    alert('Failed to upload profile photo');
                } else {
                    if (profilePhotoInput.current) profilePhotoInput.current.value = '';
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const removeProfilePhoto = async () => {
        useViewerStore.setState({isProfilePhotoAvailable: false});
        useViewerStore.setState({userProfilePhoto: undefined});
        const filename = `${user?.user_Id}.png`;
        const response = await azureBLOBStorageService.deleteFile(filename);

        if (response !== true) {
            alert('Failed to delete profile photo');
        }
    };

    const handleMenuClick = (e: any) => {
        if (e.key === 'remove') {
            removeProfilePhoto();
        } else if (e.key === 'edit') {
            profilePhotoInput.current?.click();
        }
    };
    const menuItems: MenuProps['items'] = [
        {
            key: 'edit',
            icon: <EditOutlined />,
            label: 'Edit Image',
        },
        ...(isProfilePhotoAvailable
            ? [
                {
                    key: 'remove',
                    icon: <DeleteOutlined />,
                    label: 'Remove Image',
                    danger: true,
                },
            ]
            : []),
    ];




    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <Dropdown
                menu={{items: menuItems, onClick: handleMenuClick}}
                trigger={['click']}
                open={open}
                onOpenChange={(flag) => setOpen(flag)}
            >
                <Avatar
                    shape="square"
                    style={{cursor: 'pointer'}}
                    size={64}
                    onClick={() => setOpen(!open)}
                    icon={isProfilePhotoAvailable ? (
                        <img src={userProfilePhoto} alt="profile"/>
                    ) : (
                        <UserOutlined/>
                    )}
                />
            </Dropdown>
            <input
                accept={".png, .jpg, .jpeg"}
                onChange={uploadProfilePhotoHandler}
                ref={profilePhotoInput}
                type="file"
                style={{display: 'none'}}
            />
        </div>
    );
};

export default ProfileAvatar;